import React from 'react'
import { HorizontalStack } from '@ztechapps/webui.util'
import type { ChatInputProps } from '../Chat/chatComponents'
import { useConversationContext } from './Context'

export const LeftContent = ({ ...props }: ChatInputProps) => {
  const { insertMessage, status } = props
  const {
    templateCategory,
    templateVariables,
    templateVariableConfirmDialogConfigs,
    templateSelectComponent: TemplateSelect,
  } = useConversationContext()

  if (!TemplateSelect) return null

  return (
    <HorizontalStack gap={2}>
      <div className="flex-fill   ">
        <TemplateSelect
          insertMessage={insertMessage}
          templateCategory={templateCategory}
          templateVariables={templateVariables}
          templateVariableConfirmDialogConfigs={templateVariableConfirmDialogConfigs}
          // While busy (sending or formalizing) a pick would write into a draft that's about to
          // be cleared or overwritten.
          disabled={status?.busy}
        />
      </div>
    </HorizontalStack>
  )
}
